// Portal asset tags (spec §6.2 step 3). PURE, shared by the PATCH route, the
// list's tag filter and (later) bulk add/remove tags, so a tag means the same
// thing wherever it is typed.
//
// Normalised: trimmed, lowercased, internal whitespace collapsed; empties
// dropped; duplicates removed (first occurrence keeps its place).
// ⚠️ Over the limits is REFUSED, never truncated: silently dropping a club's
// 31st tag is absence read as a value.

export const MAX_ASSET_TAGS = 30;
export const MAX_ASSET_TAG_LENGTH = 40;

export function normalizeAssetTag(raw: string): string {
  return raw.trim().toLowerCase().replace(/\s+/g, ' ');
}

export type TagNormalization = { ok: true; tags: string[] } | { ok: false; reason: string };

export function normalizeAssetTags(raw: readonly string[]): TagNormalization {
  const tags: string[] = [];
  for (const r of raw) {
    const t = normalizeAssetTag(r);
    if (!t || tags.includes(t)) continue;
    if (t.length > MAX_ASSET_TAG_LENGTH) {
      return { ok: false, reason: `A tag can be at most ${MAX_ASSET_TAG_LENGTH} characters (“${t.slice(0, 20)}…”).` };
    }
    tags.push(t);
  }
  if (tags.length > MAX_ASSET_TAGS) return { ok: false, reason: `An asset can have at most ${MAX_ASSET_TAGS} tags.` };
  return { ok: true, tags };
}
